import { Ability } from "@/interfaces/ability";
import { defineStore } from "pinia";
import { ref } from "vue";

export const useUserAbilitiesStore = defineStore("userAbilities", () => {
  const userAbilities = ref<Ability[]>([]);

  return {
    userAbilities,

    setUserAbilities(abilities: Ability[]) {
      userAbilities.value = abilities;
    },
  };
});
